//ModuleVersionId:5e6dee00-0ff6-4130-92a8-f9c9a6b89734
// generated at 04/23/2025 12:55:15
/* tslint:disable:max-line-length */
import instances from 'InstanceFactory';
import enums from '../Enums';
import {ServiceProviderBase} from './ServiceProviderBase';

export class ServiceProvider extends ServiceProviderBase {
    public addUsersToAdmitted(ids: string[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'addUsersToAdmitted',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                ids
            })

        });
    }
    public addUsersToRejected(ids: string[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'addUsersToRejected',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                ids
            })

        });
    }
    public calculateRegressionMetric(projectId: Guid, regressionMetric: instances.RegressionMetric): JQueryPromise<instances.RegressionParameters> {
        return this.executeServiceMethod<instances.RegressionParameters>({
            methodName: 'calculateRegressionMetric',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                regressionMetric
            })

        });
    }
    public cancelProjectImport(projectId: Guid, filePath: string): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'cancelProjectImport',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                filePath
            })

        });
    }
    public changeDimensionIds(projectId: Guid, documentIds: Guid[], oldId: string, newId: string): JQueryPromise<instances.ChangeDimensionIdResult> {
        return this.executeServiceMethod<instances.ChangeDimensionIdResult>({
            methodName: 'changeDimensionIds',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentIds,
                oldId,
                newId
            })

        });
    }
    public changeLocale(locale: string): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'changeLocale',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                locale
            })

        });
    }
    public changePassword(oldPassword: string, newPassword: string): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'changePassword',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                oldPassword,
                newPassword
            })

        });
    }
    public changeTestCaseComment(projectId: Guid, testCaseId: Guid, comment: string): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'changeTestCaseComment',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testCaseId,
                comment
            })

        });
    }
    public checkDatabaseExist(projectId: Guid): JQueryPromise<boolean> {
        return this.executeServiceMethod<boolean>({
            methodName: 'checkDatabaseExist',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public checkDataLoad(projectId: Guid, taskId?: Guid, advanced?: boolean): JQueryPromise<instances.DataLoadInfoContainer> {
        return this.executeServiceMethod<instances.DataLoadInfoContainer>({
            methodName: 'checkDataLoad',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            },
            _.isUndefined(taskId) ? null : {taskId},
            _.isUndefined(advanced) ? null : {advanced}
            )
        });
    }
    public checkDbVersion(projectId: Guid): JQueryPromise<instances.DbVersionExceptionFault> {
        return this.executeServiceMethod<instances.DbVersionExceptionFault>({
            methodName: 'checkDbVersion',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public checkDocumentBeforeSave(projectId: Guid, doc: instances.IIdentifiable): JQueryPromise<instances.CheckResponse> {
        return this.executeServiceMethod<instances.CheckResponse>({
            methodName: 'checkDocumentBeforeSave',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                doc
            })

        });
    }
    public checkFtpServer(projectId: Guid, server: instances.ServerDS): JQueryPromise<instances.FtpServerTestResult> {
        return this.executeServiceMethod<instances.FtpServerTestResult>({
            methodName: 'checkFtpServer',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                server
            })

        });
    }
    public checkProjectBeforePublish(projectId: Guid): JQueryPromise<instances.ProblemDescription[]> {
        return this.executeServiceMethod<instances.ProblemDescription[]>({
            methodName: 'checkProjectBeforePublish',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public checkSession(projectId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'checkSession',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public clearCache(projectId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'clearCache',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public clearDataLoadLog(projectId: Guid, planId: Guid, isExclude?: boolean): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'clearDataLoadLog',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                planId
            },
            _.isUndefined(isExclude) ? null : {isExclude}
            )
        });
    }
    public copyDocument(projectId: Guid, documentId: Guid, documentName: string, newName: string, newParentId: Guid): JQueryPromise<instances.DocumentWithChilds> {
        return this.executeServiceMethod<instances.DocumentWithChilds>({
            methodName: 'copyDocument',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentId,
                documentName,
                newName,
                newParentId
            })

        });
    }
    public copyTestRunToExpected(projectId: Guid, testRunIds: Guid[], isCurrentTestRunSession?: boolean): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'copyTestRunToExpected',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testRunIds
            },
            _.isUndefined(isCurrentTestRunSession) ? null : {isCurrentTestRunSession}
            )
        });
    }
    public createProject(project: instances.ProjectDefinition, dataConnectionInfo: instances.ConnectionInformation, stagingConnectionInfo: instances.ConnectionInformation, importProjectZipPath: string, overrideIfExists: boolean, tenantId?: string): JQueryPromise<instances.ProjectImportResult> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.ProjectImportResult>({
            methodName: 'createProject',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                project,
                dataConnectionInfo,
                stagingConnectionInfo,
                importProjectZipPath,
                overrideIfExists
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public deleteAllEndedProfilerSessions(): JQueryPromise<instances.ProfilerSession> {
        return this.executeServiceMethod<instances.ProfilerSession>({
            methodName: 'deleteAllEndedProfilerSessions',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            })

        });
    }
    public deleteDataForDocument(projectId: Guid, documents: Guid[], dataLoadParameter: instances.DataLoadParameter): JQueryPromise<number> {
        return this.executeServiceMethod<number>({
            methodName: 'deleteDataForDocument',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documents,
                dataLoadParameter
            })

        });
    }
    public deleteDocument(projectId: Guid, documentId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'deleteDocument',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentId
            })

        });
    }
    public deleteEndedProfilerSessions(profilerSessionsIds: Guid[]): JQueryPromise<instances.ProfilerSession> {
        return this.executeServiceMethod<instances.ProfilerSession>({
            methodName: 'deleteEndedProfilerSessions',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                profilerSessionsIds
            })

        });
    }
    public deleteGlobalObjectById(objectType: string, id: Guid, tenantId?: string): JQueryPromise<instances.DocumentReferences> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.DocumentReferences>({
            methodName: 'deleteGlobalObjectById',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                objectType,
                id
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public deleteGlobalObjects(objects: instances.InsightObject[], tenantId?: string): JQueryPromise<void> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<void>({
            methodName: 'deleteGlobalObjects',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                objects
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public deleteHistory(projectId: Guid, itemGuids: Guid[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'deleteHistory',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                itemGuids
            })

        });
    }
    public deleteJob(projectId: Guid, jobId: number, isDeleteLoadedData: boolean): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'deleteJob',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                jobId,
                isDeleteLoadedData
            })

        });
    }
    public deleteLicense(projectId: Guid, license: string, tenantId?: string): JQueryPromise<void> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<void>({
            methodName: 'deleteLicense',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                license
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public deleteTaskLogs(projectId: Guid, taskLogId: number): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'deleteTaskLogs',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                taskLogId
            })

        });
    }
    public deleteTestRunSession(projectId: Guid, testRunSessionIds: Guid[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'deleteTestRunSession',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testRunSessionIds
            })

        });
    }
    public deleteUploadedFile(projectId: Guid, fileName: string, container: enums.StorageContainerType): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'deleteUploadedFile',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                fileName,
                container
            })

        });
    }
    public downloadFile(fileId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'downloadFile',
            httpMethod: 'GET',
            sessionIdName: 'sessionId',
            data: _.assign({
                fileId
            })

        });
    }
    public editRecord(projectId: Guid, data: instances.EditRecordData): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'editRecord',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                data
            })

        });
    }
    public eMailTestRunSession(projectId: Guid, testRunSessionId: Guid, parameters: instances.TestSessionEMailParameters): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'eMailTestRunSession',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testRunSessionId,
                parameters
            })

        });
    }
    public executeQuery(projectId: Guid, query: instances.TypedQuery[], metricPool: instances.MetricPool, standardMetricId: Guid, dateTimeInterval: instances.DateTimeInterval, filters: instances.QueryParameterValue[]): JQueryPromise<instances.QueryExecutionResult> {
        return this.executeServiceMethod<instances.QueryExecutionResult>({
            methodName: 'executeQuery',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                query,
                metricPool,
                standardMetricId,
                dateTimeInterval,
                filters
            })

        });
    }
    public executeWSCall(projectId: Guid, wsCall: instances.WSCallConfiguration, fieldValues: instances.WSCallFieldParam[], withRequest?: boolean): JQueryPromise<instances.WSCallResponse> {
        return this.executeServiceMethod<instances.WSCallResponse>({
            methodName: 'executeWSCall',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                wsCall,
                fieldValues
            },
            _.isUndefined(withRequest) ? null : {withRequest}
            )
        });
    }
    public exportAdminData(documents: instances.DocumentDescriptor[], saveSelections: boolean, clearDataSources: boolean, tenantId?: string): JQueryPromise<Guid> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<Guid>({
            methodName: 'exportAdminData',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                documents,
                saveSelections,
                clearDataSources
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public exportLogArchive(logfiles: enums.LogFilesType[], interval: instances.DateTimeInterval, allTenantsLogs: boolean, tenantId?: string): JQueryPromise<instances.FileDownloadResult> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.FileDownloadResult>({
            methodName: 'exportLogArchive',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                logfiles,
                interval,
                allTenantsLogs
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public exportLogs(allTenantsLogs: boolean, tenantId?: string): JQueryPromise<Guid> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<Guid>({
            methodName: 'exportLogs',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                allTenantsLogs
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public exportProjectData(projectId: Guid, exportProjectOptions: instances.ExportProjectOptions): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'exportProjectData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                exportProjectOptions
            })

        });
    }
    public exportToExcel(projectId: Guid, component: instances.BaseComponent, globalFilters: instances.GroupFilter[], parentIds: Guid[]): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'exportToExcel',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                component,
                globalFilters,
                parentIds
            })

        });
    }
    public extractToFormattedExcel(projectId: Guid, reportId: Guid, report: instances.Report, viewComponent: instances.ViewComponent, gridPrintSettings: instances.GridPrintSettings, sendByEmail: boolean, emails: string[]): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'extractToFormattedExcel',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                reportId,
                report,
                viewComponent,
                gridPrintSettings,
                sendByEmail,
                emails
            })

        });
    }
    public findBestAppropriateGroup(projectId: Guid, olapCubeId: Guid, dateTimeField: string, timeLevel: string): JQueryPromise<instances.FindBestGroupResult> {
        return this.executeServiceMethod<instances.FindBestGroupResult>({
            methodName: 'findBestAppropriateGroup',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                olapCubeId,
                dateTimeField,
                timeLevel
            })

        });
    }
    public findDocumentUsages(projectId: Guid, documentId: Guid, documentCategory: string, dimensionId?: string, tenantId?: string): JQueryPromise<instances.DocumentReferences> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.DocumentReferences>({
            methodName: 'findDocumentUsages',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentId,
                documentCategory
            },
            _.isUndefined(dimensionId) ? null : {dimensionId},
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public fixBrokenReferences(projectId: Guid, brokenLinks: instances.BrokenLink[]): JQueryPromise<instances.BrokenLink[]> {
        return this.executeServiceMethod<instances.BrokenLink[]>({
            methodName: 'fixBrokenReferences',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                brokenLinks
            })

        });
    }
    public generateLocalizationTables(projectId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'generateLocalizationTables',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public generateQueryForDocument(projectId: Guid, document: instances.DocumentBase): JQueryPromise<instances.QueryDescription> {
        return this.executeServiceMethod<instances.QueryDescription>({
            methodName: 'generateQueryForDocument',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                document
            })

        });
    }
    public generateRModel(projectId: Guid, modelId: Guid, dateTimeRange: instances.DateTimeRange): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'generateRModel',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                modelId,
                dateTimeRange
            })

        });
    }
    public generateStandardMetricQuery(projectId: Guid, metricPool: instances.MetricPool, standardMetricId: Guid, queryDefinition: instances.QueryDefinition): JQueryPromise<instances.TypedQuery[]> {
        return this.executeServiceMethod<instances.TypedQuery[]>({
            methodName: 'generateStandardMetricQuery',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                metricPool,
                standardMetricId,
                queryDefinition
            })

        });
    }
    public getAdminDashboardData(tenantId?: string): JQueryPromise<instances.AdminDashboardData> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.AdminDashboardData>({
            methodName: 'getAdminDashboardData',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public getAdminImportData(data: { $type: string, $value: string } | number[], tenantId?: string): JQueryPromise<instances.AdminImportData> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.AdminImportData>({
            methodName: 'getAdminImportData',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                data
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public getAllGlobalObjects(objectTypes: string[], tenantId?: string): JQueryPromise<instances.InsightObject[]> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.InsightObject[]>({
            methodName: 'getAllGlobalObjects',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                objectTypes
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public getAllMaskedDimensions(projectId: Guid): JQueryPromise<instances.MaskedDimension[]> {
        return this.executeServiceMethod<instances.MaskedDimension[]>({
            methodName: 'getAllMaskedDimensions',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getAllNamedUsers(tenantId?: string): JQueryPromise<instances.NamedUserInfo[]> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.NamedUserInfo[]>({
            methodName: 'getAllNamedUsers',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public getAllProfilerSessions(): JQueryPromise<instances.ProfilerSession[]> {
        return this.executeServiceMethod<instances.ProfilerSession[]>({
            methodName: 'getAllProfilerSessions',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            })

        });
    }
    public getAuditItems(projectId: Guid, filter: instances.AuditItemsFilter): JQueryPromise<instances.AuditEntry[]> {
        return this.executeServiceMethod<instances.AuditEntry[]>({
            methodName: 'getAuditItems',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                filter
            })

        });
    }
    public getBatchFiles(projectId: Guid, batchFile: instances.BatchFileDS): JQueryPromise<string[]> {
        return this.executeServiceMethod<string[]>({
            methodName: 'getBatchFiles',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                batchFile
            })

        });
    }
    public getBrokenReferences(projectId: Guid): JQueryPromise<instances.BrokenLink[]> {
        return this.executeServiceMethod<instances.BrokenLink[]>({
            methodName: 'getBrokenReferences',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getCachedModel(userId: string, ticks: string, locale: string, version: string, viewType: string, isPrint: string, bookmarkId: string, reportId: string, themeId: string, tenantId: string): JQueryPromise<instances.ViewerModel> {
        return this.executeServiceMethod<instances.ViewerModel>({
            methodName: 'getCachedModel',
            httpMethod: 'GET',
            cached: true,
            sessionIdName: 'sessionId',
            data: _.assign({
                userId,
                ticks,
                locale,
                version,
                viewType,
                isPrint,
                bookmarkId,
                reportId,
                themeId,
                tenantId
            })

        });
    }
    public getCurrentProfilerSession(): JQueryPromise<instances.ProfilerSession> {
        return this.executeServiceMethod<instances.ProfilerSession>({
            methodName: 'getCurrentProfilerSession',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            })

        });
    }
    public getData(projectId: Guid, configuration: instances.DataRequestConfiguration): JQueryPromise<instances.ComponentData> {
        return this.executeServiceMethod<instances.ComponentData>({
            methodName: 'getData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                configuration
            })

        });
    }
    public getDataDatabaseType(projectId: Guid): JQueryPromise<string> {
        return this.executeServiceMethod<string>({
            methodName: 'getDataDatabaseType',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getDataLoadHistory(projectId: Guid): JQueryPromise<instances.HistoryItem[]> {
        return this.executeServiceMethod<instances.HistoryItem[]>({
            methodName: 'getDataLoadHistory',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getDataSourceTable(projectId: Guid, dataSourceId: Guid, tableName: string): JQueryPromise<instances.DataSourceTable> {
        return this.executeServiceMethod<instances.DataSourceTable>({
            methodName: 'getDataSourceTable',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                dataSourceId,
                tableName
            })

        });
    }
    public getDescriptorsByCategoryies(projectId: Guid, documentCategories: string[]): JQueryPromise<instances.DocumentDescriptor[]> {
        return this.executeServiceMethod<instances.DocumentDescriptor[]>({
            methodName: 'getDescriptorsByCategoryies',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentCategories
            })

        });
    }
    public getDimensions(projectId: Guid, categories: string[]): JQueryPromise<any[]> {
        return this.executeServiceMethod<any[]>({
            methodName: 'getDimensions',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                categories
            })

        });
    }
    public getDirectoryItems(projectId: Guid, directory: string, includeFiles: boolean, ext: string[], container: enums.StorageContainerType): JQueryPromise<instances.ItemInfo[]> {
        return this.executeServiceMethod<instances.ItemInfo[]>({
            methodName: 'getDirectoryItems',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                directory,
                includeFiles,
                ext,
                container
            })

        });
    }
    public getDocumentFolders(projectId: Guid, documentItems: instances.DocumentItem[]): JQueryPromise<instances.FullPathItem[]> {
        return this.executeServiceMethod<instances.FullPathItem[]>({
            methodName: 'getDocumentFolders',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentItems
            })

        });
    }
    public getDocumentsForDimensionManager(projectId: Guid): JQueryPromise<instances.DimensionDocument[]> {
        return this.executeServiceMethod<instances.DimensionDocument[]>({
            methodName: 'getDocumentsForDimensionManager',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getDynamicItems(projectIds: Guid[]): JQueryPromise<instances.DynamicMenuResult[]> {
        return this.executeServiceMethod<instances.DynamicMenuResult[]>({
            methodName: 'getDynamicItems',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                projectIds
            })

        });
    }
    public getExportDocuments(projectId: Guid): JQueryPromise<instances.ExportDocument[]> {
        return this.executeServiceMethod<instances.ExportDocument[]>({
            methodName: 'getExportDocuments',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getGeoLayerDataDef(projectId: Guid, layer: Guid, filters: _.Dictionary<string>): JQueryPromise<instances.GeoShapeDefinition[]> {
        return this.executeServiceMethod<instances.GeoShapeDefinition[]>({
            methodName: 'getGeoLayerDataDef',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                layer,
                filters
            })

        });
    }
    public getGlobalObject(objectType: string, id: Guid, tenantId?: string): JQueryPromise<instances.InsightObject> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.InsightObject>({
            methodName: 'getGlobalObject',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                objectType,
                id
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public getGlobalPlanProjectDimensions(projectId: Guid, manifestId: Guid, filterdObjects: Guid[]): JQueryPromise<instances.GlobalPlanProjectDimension[]> {
        return this.executeServiceMethod<instances.GlobalPlanProjectDimension[]>({
            methodName: 'getGlobalPlanProjectDimensions',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                manifestId,
                filterdObjects
            })

        });
    }
    public getGlobalPlanProjectDocuments(projectId: Guid, manifestId: Guid, filterObjects: Guid[]): JQueryPromise<instances.NodeProjectDocumentReference[]> {
        return this.executeServiceMethod<instances.NodeProjectDocumentReference[]>({
            methodName: 'getGlobalPlanProjectDocuments',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                manifestId,
                filterObjects
            })

        });
    }
    public getGuideData(projectId: Guid, categories: string[]): JQueryPromise<instances.GuideSection[]> {
        return this.executeServiceMethod<instances.GuideSection[]>({
            methodName: 'getGuideData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                categories
            })

        });
    }
    public getImportResult(projectId: Guid, operationId: Guid): JQueryPromise<instances.ProjectImportResult> {
        return this.executeServiceMethod<instances.ProjectImportResult>({
            methodName: 'getImportResult',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                operationId
            })

        });
    }
    public getJobErrors(projectId: Guid, jobId: number, count: number): JQueryPromise<string> {
        return this.executeServiceMethod<string>({
            methodName: 'getJobErrors',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                jobId,
                count
            })

        });
    }
    public getJobList(projectId: Guid, statuses: enums.ExecutionStatus[], executedFrom: Date | null, executedTo: Date | null): JQueryPromise<instances.JobDetails[]> {
        return this.executeServiceMethod<instances.JobDetails[]>({
            methodName: 'getJobList',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                statuses,
                executedFrom,
                executedTo
            })

        });
    }
    public getJobLog(projectId: Guid, jobId: number, fromId: number, fromErrorId: number): JQueryPromise<instances.JobLogDS> {
        return this.executeServiceMethod<instances.JobLogDS>({
            methodName: 'getJobLog',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                jobId,
                fromId,
                fromErrorId
            })

        });
    }
    public getLicenseSetting(projectId: Guid, onlyMerged?: boolean, tenantId?: string, settings?: instances.LicenseSettings): JQueryPromise<instances.LicenseResponse> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.LicenseResponse>({
            methodName: 'getLicenseSetting',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            },
            _.isUndefined(onlyMerged) ? null : {onlyMerged},
            _.isUndefined(tenantId) ? null : {tenantId},
            _.isUndefined(settings) ? null : {settings}
            )
        });
    }
    public getLogFromScheduler(projectId: Guid): JQueryPromise<instances.LogItem[]> {
        return this.executeServiceMethod<instances.LogItem[]>({
            methodName: 'getLogFromScheduler',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getManifestAnalysisStatus(projectId: Guid): JQueryPromise<instances.OptimizationAnalysisInfo> {
        return this.executeServiceMethod<instances.OptimizationAnalysisInfo>({
            methodName: 'getManifestAnalysisStatus',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getMapData(projectId: Guid, parameter: instances.MapParameter): JQueryPromise<instances.MapData> {
        return this.executeServiceMethod<instances.MapData>({
            methodName: 'getMapData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                parameter
            })

        });
    }
    public getMenuSearchResults(viewItems: instances.ViewObject[]): JQueryPromise<instances.MenuSearchResult[]> {
        return this.executeServiceMethod<instances.MenuSearchResult[]>({
            methodName: 'getMenuSearchResults',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                viewItems
            })

        });
    }
    public getMetricData(projectId: Guid, metricId: Guid, metricName: string, interval: instances.DateTimeInterval, maxCount: number): JQueryPromise<instances.MetricData> {
        return this.executeServiceMethod<instances.MetricData>({
            methodName: 'getMetricData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                metricId,
                metricName,
                interval,
                maxCount
            })

        });
    }
    public getModel(applicationType: enums.ApplicationType, tenantId: string): JQueryPromise<instances.BaseModel> {
        return this.executeServiceMethod<instances.BaseModel>({
            methodName: 'getModel',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                applicationType,
                tenantId
            })

        });
    }
    public getMultiTenantImportData(filePath: string): JQueryPromise<instances.MultiTenantImportData> {
        return this.executeServiceMethod<instances.MultiTenantImportData>({
            methodName: 'getMultiTenantImportData',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                filePath
            })

        });
    }
    public getMultiTenantImportResult(resultId: Guid): JQueryPromise<instances.MultiTenantImportResult> {
        return this.executeServiceMethod<instances.MultiTenantImportResult>({
            methodName: 'getMultiTenantImportResult',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                resultId
            })

        });
    }
    public getOperationResult(projectId: Guid, resultId: Guid): JQueryPromise<instances.ProcessingResult> {
        return this.executeServiceMethod<instances.ProcessingResult>({
            methodName: 'getOperationResult',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                resultId
            })

        });
    }
    public getProcessChartData(projectId: Guid, configuration: instances.ProcessConfiguration): JQueryPromise<instances.ProcessChartData> {
        return this.executeServiceMethod<instances.ProcessChartData>({
            methodName: 'getProcessChartData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                configuration
            })

        });
    }
    public getProcessGridData(projectId: Guid, configuration: instances.ProcessConfiguration): JQueryPromise<instances.ComponentData> {
        return this.executeServiceMethod<instances.ComponentData>({
            methodName: 'getProcessGridData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                configuration
            })

        });
    }
    public getProjectImportData(projectId: Guid, filePath: string): JQueryPromise<instances.ProjectImportData> {
        return this.executeServiceMethod<instances.ProjectImportData>({
            methodName: 'getProjectImportData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                filePath
            })

        });
    }
    public getProjectsNeedToUpdate(tenantId: Guid): JQueryPromise<instances.UpdateResult[]> {
        return this.executeServiceMethod<instances.UpdateResult[]>({
            methodName: 'getProjectsNeedToUpdate',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                tenantId
            })

        });
    }
    public getProjectTestRunSessionState(projectId: Guid, testRunsStartIndex?: number | null): JQueryPromise<instances.TestRunSessionState> {
        return this.executeServiceMethod<instances.TestRunSessionState>({
            methodName: 'getProjectTestRunSessionState',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            },
            _.isUndefined(testRunsStartIndex) ? null : {testRunsStartIndex}
            )
        });
    }
    public getRecordDimensionData(projectId: Guid, configuration: instances.RecordDimensionConfiguration): JQueryPromise<instances.ComponentData> {
        return this.executeServiceMethod<instances.ComponentData>({
            methodName: 'getRecordDimensionData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                configuration
            })

        });
    }
    public getRModelScript(projectId: Guid, modelId: Guid, dateTimeRange: instances.DateTimeRange): JQueryPromise<string> {
        return this.executeServiceMethod<string>({
            methodName: 'getRModelScript',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                modelId,
                dateTimeRange
            })

        });
    }
    public getSapVariableValues(projectId: Guid, connection: instances.ConnectionInformation, variable: instances.SapVariable): JQueryPromise<instances.SapObjectId[]> {
        return this.executeServiceMethod<instances.SapObjectId[]>({
            methodName: 'getSapVariableValues',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                connection,
                variable
            })

        });
    }
    public getScheduledTasks(projectId: Guid, from: Date, to: Date): JQueryPromise<instances.TaskItem[]> {
        return this.executeServiceMethod<instances.TaskItem[]>({
            methodName: 'getScheduledTasks',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                from,
                to
            })

        });
    }
    public getSchemas(projectId: Guid, connection: instances.ConnectionInformation): JQueryPromise<string[]> {
        return this.executeServiceMethod<string[]>({
            methodName: 'getSchemas',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                connection
            })

        });
    }
    public getShapefileMetaFields(projectId: Guid, fileName: string): JQueryPromise<string[]> {
        return this.executeServiceMethod<string[]>({
            methodName: 'getShapefileMetaFields',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                fileName
            })

        });
    }
    public getSheetNames(projectId: Guid, container: enums.StorageContainerType, filename: string): JQueryPromise<string[]> {
        return this.executeServiceMethod<string[]>({
            methodName: 'getSheetNames',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                container,
                filename
            })

        });
    }
    public getSimpleTestResults(projectId: Guid, testId: Guid): JQueryPromise<instances.TestSimpleResults> {
        return this.executeServiceMethod<instances.TestSimpleResults>({
            methodName: 'getSimpleTestResults',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testId
            })

        });
    }
    public getStagingDataSource(projectId: Guid): JQueryPromise<instances.DataSource> {
        return this.executeServiceMethod<instances.DataSource>({
            methodName: 'getStagingDataSource',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getSwimlaneData(projectId: Guid, configuration: instances.ProcessConfiguration): JQueryPromise<instances.SwimlaneChartData> {
        return this.executeServiceMethod<instances.SwimlaneChartData>({
            methodName: 'getSwimlaneData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                configuration
            })

        });
    }
    public getTableFields(projectId: Guid, connection: instances.ConnectionInformation, table: string, id: Guid): JQueryPromise<instances.DataSourceTable> {
        return this.executeServiceMethod<instances.DataSourceTable>({
            methodName: 'getTableFields',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                connection,
                table,
                id
            })

        });
    }
    public getTableNames(projectId: Guid, connectionInfo: instances.ConnectionInformation, schemas: string[], tableMask: string, useView?: boolean): JQueryPromise<instances.GetTableNameResponce> {
        return this.executeServiceMethod<instances.GetTableNameResponce>({
            methodName: 'getTableNames',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                connectionInfo,
                schemas,
                tableMask
            },
            _.isUndefined(useView) ? null : {useView}
            )
        });
    }
    public getTableRecords(projectId: Guid, connectionInfo: instances.ConnectionInformation, schemas: string[], tableMask: string, useView?: boolean): JQueryPromise<instances.DataSourceTable[]> {
        return this.executeServiceMethod<instances.DataSourceTable[]>({
            methodName: 'getTableRecords',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                connectionInfo,
                schemas,
                tableMask
            },
            _.isUndefined(useView) ? null : {useView}
            )
        });
    }
    public getTaskLogs(projectId: Guid, events: enums.TaskLogEventType[], createdFrom: Date | null, createdTo: Date | null): JQueryPromise<instances.TaskLog[]> {
        return this.executeServiceMethod<instances.TaskLog[]>({
            methodName: 'getTaskLogs',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                events,
                createdFrom,
                createdTo
            })

        });
    }
    public getTenantsNeedToUpdate(): JQueryPromise<instances.UpdateResult[]> {
        return this.executeServiceMethod<instances.UpdateResult[]>({
            methodName: 'getTenantsNeedToUpdate',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            })

        });
    }
    public getTestCaseDetails(projectId: Guid, testCaseId: Guid): JQueryPromise<instances.TestRunView> {
        return this.executeServiceMethod<instances.TestRunView>({
            methodName: 'getTestCaseDetails',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testCaseId
            })

        });
    }
    public getTestCasesTreeView(projectId: Guid): JQueryPromise<instances.DocumentDescriptor[]> {
        return this.executeServiceMethod<instances.DocumentDescriptor[]>({
            methodName: 'getTestCasesTreeView',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getTestRuns(projectId: Guid, testRunSessionId: Guid, includeTestCases?: boolean, configuration?: instances.TestProjectViewConfiguration): JQueryPromise<any> {
        return this.executeServiceMethod<any>({
            methodName: 'getTestRuns',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testRunSessionId
            },
            _.isUndefined(includeTestCases) ? null : {includeTestCases},
            _.isUndefined(configuration) ? null : {configuration}
            )
        });
    }
    public getTestRunsCompare(projectId: Guid, testRunId: Guid, isCurrentTestRunSession?: boolean): JQueryPromise<instances.TestRunsCompareView> {
        return this.executeServiceMethod<instances.TestRunsCompareView>({
            methodName: 'getTestRunsCompare',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testRunId
            },
            _.isUndefined(isCurrentTestRunSession) ? null : {isCurrentTestRunSession}
            )
        });
    }
    public getTestRunSessions(projectId: Guid, configuration?: instances.TestProjectViewConfiguration): JQueryPromise<any> {
        return this.executeServiceMethod<any>({
            methodName: 'getTestRunSessions',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            },
            _.isUndefined(configuration) ? null : {configuration}
            )
        });
    }
    public getTrellisProcessChartData(projectId: Guid, configuration: instances.ProcessConfiguration): JQueryPromise<instances.TrellisProcessChartData> {
        return this.executeServiceMethod<instances.TrellisProcessChartData>({
            methodName: 'getTrellisProcessChartData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                configuration
            })

        });
    }
    public getTrellisSwimlaneData(projectId: Guid, configuration: instances.ProcessConfiguration): JQueryPromise<instances.TrellisSwimlaneChartData> {
        return this.executeServiceMethod<instances.TrellisSwimlaneChartData>({
            methodName: 'getTrellisSwimlaneData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                configuration
            })

        });
    }
    public getUser(): JQueryPromise<instances.User> {
        return this.executeServiceMethod<instances.User>({
            methodName: 'getUser',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            })

        });
    }
    public getUserReportSubscriptions(projectId: Guid): JQueryPromise<instances.ReportSubscription[]> {
        return this.executeServiceMethod<instances.ReportSubscription[]>({
            methodName: 'getUserReportSubscriptions',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public getViewerModel(parameter: instances.HtmlParameter): JQueryPromise<instances.ViewerModel> {
        return this.executeServiceMethod<instances.ViewerModel>({
            methodName: 'getViewerModel',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                parameter
            })

        });
    }
    public importAdminData(importData: instances.AdminImportData, overwrite: boolean, tenantId?: string): JQueryPromise<string[]> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<string[]>({
            methodName: 'importAdminData',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                importData,
                overwrite
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public importProjectData(projectId: Guid, importOptions: instances.ImportProjectOptions): JQueryPromise<instances.ProjectImportResult> {
        return this.executeServiceMethod<instances.ProjectImportResult>({
            methodName: 'importProjectData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                importOptions
            })

        });
    }
    public importSolution(project: instances.ProjectDefinition, importSolutionZipPath: string, overrideIfExists: boolean): JQueryPromise<instances.ProjectImportResult> {
        return this.executeServiceMethod<instances.ProjectImportResult>({
            methodName: 'importSolution',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                project,
                importSolutionZipPath,
                overrideIfExists
            })

        });
    }
    public isFileExist(projectId: Guid, fileName: string, container: enums.StorageContainerType, tenantId?: string): JQueryPromise<boolean> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<boolean>({
            methodName: 'isFileExist',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                fileName,
                container
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public isTestFinished(projectId: Guid, testId: Guid): JQueryPromise<boolean> {
        return this.executeServiceMethod<boolean>({
            methodName: 'isTestFinished',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testId
            })

        });
    }
    public loadCachedProjectModel(userId: string, ticks: string, globalModelTicks: string, locale: string, version: string, projectId: string): JQueryPromise<instances.ProjectModel> {
        return this.executeServiceMethod<instances.ProjectModel>({
            methodName: 'loadCachedProjectModel',
            httpMethod: 'GET',
            cached: true,
            sessionIdName: 'sessionId',
            data: _.assign({
                userId,
                ticks,
                globalModelTicks,
                locale,
                version,
                projectId
            })

        });
    }
    public loadCachedView(userId: string, ticks: string, globalModelTicks: string, locale: string, version: string, projectId: string, componentId: string, componentName: string, loadView: boolean): JQueryPromise<instances.ViewData> {
        return this.executeServiceMethod<instances.ViewData>({
            methodName: 'loadCachedView',
            httpMethod: 'GET',
            cached: true,
            sessionIdName: 'sessionId',
            data: _.assign({
                userId,
                ticks,
                globalModelTicks,
                locale,
                version,
                projectId,
                componentId,
                componentName,
                loadView
            })

        });
    }
    public loadDocument(projectId: Guid, documentId: Guid, documentName: string, documentCategory: string[]): JQueryPromise<instances.DocumentBase> {
        return this.executeServiceMethod<instances.DocumentBase>({
            methodName: 'loadDocument',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentId,
                documentName,
                documentCategory
            })

        });
    }
    public loadDocumentProxiesByCategory(projectId: Guid, documentCategories: string[]): JQueryPromise<instances.DocumentProxyBase[]> {
        return this.executeServiceMethod<instances.DocumentProxyBase[]>({
            methodName: 'loadDocumentProxiesByCategory',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentCategories
            })

        });
    }
    public loadDocumentsByCategory(projectId: Guid, documentCategories: string[]): JQueryPromise<instances.DocumentBase[]> {
        return this.executeServiceMethod<instances.DocumentBase[]>({
            methodName: 'loadDocumentsByCategory',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentCategories
            })

        });
    }
    public loadDocumentsByName(projectId: Guid, category: string, documentName: string): JQueryPromise<instances.IIdentifiable[]> {
        return this.executeServiceMethod<instances.IIdentifiable[]>({
            methodName: 'loadDocumentsByName',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                category,
                documentName
            })

        });
    }
    public loadModelChangeTime(tenantId?: string): JQueryPromise<string> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<string>({
            methodName: 'loadModelChangeTime',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public loadProjectChangeTimes(projectId: Guid): JQueryPromise<instances.ProjectChangeTimes> {
        return this.executeServiceMethod<instances.ProjectChangeTimes>({
            methodName: 'loadProjectChangeTimes',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public loadProjectModel(projectId: Guid): JQueryPromise<instances.ProjectModel> {
        return this.executeServiceMethod<instances.ProjectModel>({
            methodName: 'loadProjectModel',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public loadStudioSettings(projectId: Guid): JQueryPromise<instances.StudioSettings> {
        return this.executeServiceMethod<instances.StudioSettings>({
            methodName: 'loadStudioSettings',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public loadView(projectId: Guid, componentId: string, componentName: string, loadView: boolean): JQueryPromise<instances.ViewData> {
        return this.executeServiceMethod<instances.ViewData>({
            methodName: 'loadView',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                componentId,
                componentName,
                loadView
            })

        });
    }
    public logLoadedView(projectId: Guid, componentId: string, componentName: string, isSuccess: boolean): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'logLoadedView',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                componentId,
                componentName,
                isSuccess
            })

        });
    }
    public logoutUser(logoutSessionId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'logoutUser',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                logoutSessionId
            })

        });
    }
    public previewTemplateFile(projectId: Guid, templateDs: instances.ParsingTemplateDS): JQueryPromise<instances.PreviewTemplateDS> {
        return this.executeServiceMethod<instances.PreviewTemplateDS>({
            methodName: 'previewTemplateFile',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                templateDs
            })

        });
    }
    public printReport(projectId: Guid, reportId: Guid, report: instances.Report, viewComponent: instances.ViewComponent, bookmarkId: Guid, urlParameters: string[]): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'printReport',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                reportId,
                report,
                viewComponent,
                bookmarkId,
                urlParameters
            })

        });
    }
    public publish(projectId: Guid, reCreateDatabase: boolean): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'publish',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                reCreateDatabase
            })

        });
    }
    public readStatus(tenantId?: string): JQueryPromise<enums.ProjectStatus> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<enums.ProjectStatus>({
            methodName: 'readStatus',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public removeInsightLog(olderThan: Date, tenantId?: string): JQueryPromise<void> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<void>({
            methodName: 'removeInsightLog',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                olderThan
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public removeLogs(logfiles: enums.LogFilesType[], interval: instances.DateTimeInterval): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'removeLogs',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                logfiles,
                interval
            })

        });
    }
    public renameDocument(projectId: Guid, document: instances.DocumentDescriptor): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'renameDocument',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                document
            })

        });
    }
    public reSaveAll(projectId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'reSaveAll',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public runJob(projectId: Guid, jobId: number): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'runJob',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                jobId
            })

        });
    }
    public saveBookmark(projectId: Guid, document: instances.BookmarkDocument, snapshot: instances.DashboardSnapshot, temporary: boolean): JQueryPromise<string> {
        return this.executeServiceMethod<string>({
            methodName: 'saveBookmark',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                document,
                snapshot,
                temporary
            })

        });
    }
    public saveDocument(projectId: Guid, document: instances.DocumentBase, tenantId?: string): JQueryPromise<instances.SaveDocumentResponce> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.SaveDocumentResponce>({
            methodName: 'saveDocument',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                document
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public saveDocumentDescriptor(projectId: Guid, document: instances.DocumentDescriptor): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'saveDocumentDescriptor',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                document
            })

        });
    }
    public saveDocumentsForDimensionManager(projectId: Guid, changes: instances.DimensionDocumentChanges[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'saveDocumentsForDimensionManager',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                changes
            })

        });
    }
    public saveGlobalObject(obj: instances.InsightObject, tenantId?: string): JQueryPromise<void> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<void>({
            methodName: 'saveGlobalObject',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                obj
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public saveGlobalObjects(objects: instances.InsightObject[], tenantId?: string): JQueryPromise<void> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<void>({
            methodName: 'saveGlobalObjects',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                objects
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public saveHistory(projectId: Guid, historyItems: instances.HistoryItem[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'saveHistory',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                historyItems
            })

        });
    }
    public saveJob(projectId: Guid, job: instances.JobDS, jobId: number): JQueryPromise<number> {
        return this.executeServiceMethod<number>({
            methodName: 'saveJob',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                job,
                jobId
            })

        });
    }
    public saveLicense(projectId: Guid, license: { $type: string, $value: string } | number[], tenantId?: string): JQueryPromise<instances.InsightLicense> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<instances.InsightLicense>({
            methodName: 'saveLicense',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                license
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public saveParameters(projectId: Guid, parameterFilters: instances.DimensionFilterValues[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'saveParameters',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                parameterFilters
            })

        });
    }
    public saveProjectTestRunSession(projectId: Guid, testRunSessionId: Guid, name: string): JQueryPromise<instances.TestRunSessionState> {
        return this.executeServiceMethod<instances.TestRunSessionState>({
            methodName: 'saveProjectTestRunSession',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testRunSessionId,
                name
            })

        });
    }
    public saveStudioSettings(projectId: Guid, settings: instances.StudioSettings): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'saveStudioSettings',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                settings
            })

        });
    }
    public saveUserReportSubscription(projectId: Guid, reportId: Guid, emails: string[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'saveUserReportSubscription',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                reportId,
                emails
            })

        });
    }
    public scheduleExecutionPlan(projectId: Guid, plans: instances.DocumentBase[]): JQueryPromise<instances.SchedulePlanResponce> {
        return this.executeServiceMethod<instances.SchedulePlanResponce>({
            methodName: 'scheduleExecutionPlan',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                plans
            })

        });
    }
    public search(value: string): JQueryPromise<instances.IndexObject[]> {
        return this.executeServiceMethod<instances.IndexObject[]>({
            methodName: 'search',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                value
            })

        });
    }
    public sendTestEMail(projectId: Guid, emailSettings: instances.EMailNotificationsSettings, eMailAddress: string, tenantId?: string): JQueryPromise<void> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<void>({
            methodName: 'sendTestEMail',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                emailSettings,
                eMailAddress
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public startCreateProject(project: instances.ProjectDefinition, dataConnectionInfo: instances.ConnectionInformation, stagingConnectionInfo: instances.ConnectionInformation, importProjectZipPath: string, overrideIfExists: boolean, tenantId?: string): JQueryPromise<Guid> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<Guid>({
            methodName: 'startCreateProject',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                project,
                dataConnectionInfo,
                stagingConnectionInfo,
                importProjectZipPath,
                overrideIfExists
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public startCurrentProfilerSession(): JQueryPromise<instances.ProfilerSession> {
        return this.executeServiceMethod<instances.ProfilerSession>({
            methodName: 'startCurrentProfilerSession',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            })

        });
    }
    public startDataLoad(projectId: Guid, parameter: instances.DataLoadParameter): JQueryPromise<instances.DataLoadInfo> {
        return this.executeServiceMethod<instances.DataLoadInfo>({
            methodName: 'startDataLoad',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                parameter
            })

        });
    }
    public startImportProjectData(projectId: Guid, importOptions: instances.ImportProjectOptions): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'startImportProjectData',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                importOptions
            })

        });
    }
    public startImportSolution(project: instances.ProjectDefinition, importSolutionZipPath: string, overrideIfExists: boolean): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'startImportSolution',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                project,
                importSolutionZipPath,
                overrideIfExists
            })

        });
    }
    public startManifestAnalisys(projectId: Guid, dimensions: string[], dateTimeRange: instances.DateTimeRange, filterObjects: Guid[], ignoreAnalyzed: boolean): JQueryPromise<instances.OptimizationAnalysisInfo> {
        return this.executeServiceMethod<instances.OptimizationAnalysisInfo>({
            methodName: 'startManifestAnalisys',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                dimensions,
                dateTimeRange,
                filterObjects,
                ignoreAnalyzed
            })

        });
    }
    public startMultiTenantImport(parameters: instances.MultiTenantImportParameters): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'startMultiTenantImport',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                parameters
            })

        });
    }
    public startProjectTestRunSession(projectId: Guid, parameters?: instances.TestRunParameters): JQueryPromise<instances.TestRunSessionState> {
        return this.executeServiceMethod<instances.TestRunSessionState>({
            methodName: 'startProjectTestRunSession',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            },
            _.isUndefined(parameters) ? null : {parameters}
            )
        });
    }
    public startService(projectId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'startService',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public startTest(projectId: Guid, document: instances.DocumentBase, parameters: instances.ParameterContainer[], limitRecords: number): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'startTest',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                document,
                parameters,
                limitRecords
            })

        });
    }
    public startTestProjectCaseSession(projectId: Guid, parameters?: instances.TestCaseSessionParameters): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'startTestProjectCaseSession',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            },
            _.isUndefined(parameters) ? null : {parameters}
            )
        });
    }
    public startUpdate(projectId: Guid): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'startUpdate',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public startUpdateTenantsAdmin(tenantIds: Guid[]): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'startUpdateTenantsAdmin',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                tenantIds
            })

        });
    }
    public startUpdateTenantsProjects(tenantId: Guid, projectIds: Guid[]): JQueryPromise<Guid> {
        return this.executeServiceMethod<Guid>({
            methodName: 'startUpdateTenantsProjects',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                tenantId,
                projectIds
            })

        });
    }
    public stopCurrentProfilerSession(): JQueryPromise<instances.ProfilerSession> {
        return this.executeServiceMethod<instances.ProfilerSession>({
            methodName: 'stopCurrentProfilerSession',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
            })

        });
    }
    public stopDataLoad(projectId: Guid, parameter: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'stopDataLoad',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                parameter
            })

        });
    }
    public stopDataLoads(projectId: Guid, parameters: instances.DataLoadIdentifier[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'stopDataLoads',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                parameters
            })

        });
    }
    public stopManifestAnalysis(projectId: Guid): JQueryPromise<instances.OptimizationAnalysisInfo> {
        return this.executeServiceMethod<instances.OptimizationAnalysisInfo>({
            methodName: 'stopManifestAnalysis',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public stopProjectTestRunSession(projectId: Guid): JQueryPromise<instances.TestRunSessionState> {
        return this.executeServiceMethod<instances.TestRunSessionState>({
            methodName: 'stopProjectTestRunSession',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public stopService(projectId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'stopService',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public stopTest(projectId: Guid, testId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'stopTest',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                testId
            })

        });
    }
    public stopTestProjectCaseSession(projectId: Guid): JQueryPromise<instances.TestCaseSessionResult[]> {
        return this.executeServiceMethod<instances.TestCaseSessionResult[]>({
            methodName: 'stopTestProjectCaseSession',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public testConnection(projectId: Guid, connection: instances.ConnectionInformation): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'testConnection',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                connection
            })

        });
    }
    public tryDeleteDocuments(projectId: Guid, documentIds: Guid[]): JQueryPromise<instances.DocumentReferences[]> {
        return this.executeServiceMethod<instances.DocumentReferences[]>({
            methodName: 'tryDeleteDocuments',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentIds
            })

        });
    }
    public tryLoadDocument(projectId: Guid, documentId: Guid, documentName: string, documentCategory: string[]): JQueryPromise<instances.DocumentBase> {
        return this.executeServiceMethod<instances.DocumentBase>({
            methodName: 'tryLoadDocument',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentId,
                documentName,
                documentCategory
            })

        });
    }
    public tryLoadDocumentsByReferences(projectId: Guid, references: instances.DocumentReferenceBase[]): JQueryPromise<instances.DocumentByReference[]> {
        return this.executeServiceMethod<instances.DocumentByReference[]>({
            methodName: 'tryLoadDocumentsByReferences',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                references
            })

        });
    }
    public unCancelDataLoads(projectId: Guid, parameters: instances.DataLoadIdentifier[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'unCancelDataLoads',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                parameters
            })

        });
    }
    public unsafeDelete(projectId: Guid, documentCategory: string, docuemntIds: Guid[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'unsafeDelete',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                documentCategory,
                docuemntIds
            })

        });
    }
    public update(projectId: Guid): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'update',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
            })

        });
    }
    public updateMaskedDimensionStates(projectId: Guid, states: instances.MaskedDimension[]): JQueryPromise<void> {
        return this.executeServiceMethod<void>({
            methodName: 'updateMaskedDimensionStates',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                states
            })

        });
    }
    public updateProfilerSession(profilerSessionId: Guid, name: string, description: string): JQueryPromise<instances.ProfilerSession> {
        return this.executeServiceMethod<instances.ProfilerSession>({
            methodName: 'updateProfilerSession',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                profilerSessionId,
                name,
                description
            })

        });
    }
    public updateTableAndSave(projectId: Guid, updates: instances.TableUpdater[], doc: instances.IIdentifiable): JQueryPromise<instances.SaveDocumentResponce> {
        return this.executeServiceMethod<instances.SaveDocumentResponce>({
            methodName: 'updateTableAndSave',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                updates,
                doc
            })

        });
    }
    public uploadFile(projectId: Guid, uploadData: { $type: string, $value: string } | number[], fileName: string, appendData: boolean, container: enums.StorageContainerType, expectEncryptedConnection: boolean, tenantId?: string): JQueryPromise<string> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<string>({
            methodName: 'uploadFile',
            httpMethod: 'POST',
            tokenName: 'token',
            projectId,
            data: _.assign({
                uploadData,
                fileName,
                appendData,
                container,
                expectEncryptedConnection
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
    public writeStatus(status: enums.ProjectStatus, tenantId?: string): JQueryPromise<void> {
        tenantId = _.defaultTo(tenantId, this.tenantId);
        return this.executeServiceMethod<void>({
            methodName: 'writeStatus',
            httpMethod: 'POST',
            sessionIdName: 'sessionId',
            data: _.assign({
                status
            },
            _.isUndefined(tenantId) ? null : {tenantId}
            )
        });
    }
}
